import React from "react";
import { useLocation } from "react-router-dom";

// components

import HeaderImage from "assets/img/agentwire-heading.png";
import PhoneImages from "assets/img/phone-images.png";
import UseCasesImage from "assets/img/use-cases.png";

export default function Home() {
  const location = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return (
    <div
      style={{
        backgroundColor: "#ecf3f9",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          backgroundColor: "white",
          height: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          paddingTop: "20px",
          paddingBottom: "20px",
        }}
      >
        <img src={HeaderImage} alt="AgentWire" />
      </div>
      <img src={PhoneImages} alt="AgentWire" />
      <img
        src={UseCasesImage}
        alt="AgentWire"
        style={{ marginTop: "20px" }}
      />
    </div>
  );
}
